import { FC, useState } from 'react'
import { ChevronDownIcon } from 'lucide-react'
import { ModuleType } from '../../../types'
import {
  formatVideoLength,
  getModuleCompletedPercentage,
  getModuleVideoLength
} from '../../../utils'
import { LessonSidebarLesson } from '..'
import { StyledLessonSidebarModule } from '.'

type Props = {
  module: ModuleType
  index: number
}

const LessonSidebarModule: FC<Props> = ({ module, index }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <StyledLessonSidebarModule>
      <button className="module-header-btn" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="module-header-top">
          <span className="module-title">{module.title}</span>
          <ChevronDownIcon style={{ transform: `rotate(${!isExpanded ? 180 : 0}deg)` }} />
        </div>
        <div className="module-header-bottom">
          <span className="module-stats">
            Module {index + 1} ∙ {formatVideoLength(getModuleVideoLength(module))}
          </span>
          <span className="module-completed">
            {Math.floor(getModuleCompletedPercentage(module))}%
          </span>
        </div>
      </button>
      {isExpanded && (
        <div className="module-lesson-list">
          {module?.lessons?.map((lesson) => {
            return <LessonSidebarLesson lesson={lesson} key={module._id} />
          })}
        </div>
      )}
    </StyledLessonSidebarModule>
  )
}

export default LessonSidebarModule
